import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiService } from './api.service';
import { User } from '../models';
import { HttpClient } from '@angular/common/http';
import { of } from 'rxjs';

/**
 * UserService
 */
@Injectable({ providedIn: 'root' })
export class UserService {
  /**
   * url
   */
  public url;

  /**
   * constructor
   * @param {ApiService} apiService
   * @param {HttpClient} http
   */
  constructor(private apiService: ApiService, private http: HttpClient) {}

  /**
   * getUser
   * @returns {Observable<User>}
   */
  getUser(): Observable<User> {
    return this.apiService.get('user');
  }

  /**
   * update
   * @param {Object} data
   * @returns {Observable<User>}
   */
  update(data: Object = {}): Observable<User> {
    return this.apiService.put('/user/update', data);
  }

  /**
   * updatePassword
   * @param {Object} data
   * @returns {Observable<any>}
   */
  updatePassword(data: Object = {}): Observable<any> {
    return this.apiService.post('/user/change_password', data);
  }

  /**
   * resetPassword
   * @param {Object} data
   * @returns {Observable<any>}
   */
  resetPassword(data: Object = {}): Observable<any> {
    return this.apiService.post('user/resetpassword', data);
  }
}
